// extracted by mini-css-extract-plugin
export default {"main":"createAccount_main__yQiOv","header":"createAccount_header__w5NVw","back":"createAccount_back__iDMqe"};